import { jsPDF } from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import { Grid, Icon } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import { gql, useLazyQuery } from "@apollo/client";
import LogoSL from "assets/images/logo-sl.png";
// import LogoUPRO from "assets/images/logo-upro.png";
import EmpleadoLayout from "components/LayoutContainers/EmpleadoLayout";
import boxShadows from "assets/theme/base/boxShadows";
import EditableText from "components/EditableText";
import PdfHeader from "../components/pdfHeader";
import { formatDate } from "utils/formatters";
import { formatMoneyPuntoDecimal } from "utils/formatters";
import { Money2Text } from "utils/formatters";

const textosIniciales = [
  "Villa Mercedes (San Luis), MES de AÑO.",
  "XXXXXXX/XX",
  "....................",
  "....................",
  "Ing. / CPN / Sr.",
  "....................",
  "....................",
  "....................",
  "....................",
  "....................",
  "....................",
];

const NotaSecretario = () => {
  const documentsRef = useRef(null);
  const { id } = useParams();
  const { lg } = boxShadows;

  const [data, setData] = useState(null);
  const [textArray, setTextArray] = useState(textosIniciales);
  const [editable, setEditable] = useState(true);

  const [getMovimiento] = useLazyQuery(
    gql`
      query getMovimientos($id: ID) {
        movimientos(filter: { id: $id }) {
          id
          estado
          tipo
          user {
            username
            nombre
            apellido
          }
          sucursalDestino {
            id
            nombre
            sede {
              id
              nombre
            }
          }
          sucursalOrigen {
            id
            nombre
            sede {
              id
              nombre
            }
          }
          observaciones
          movimientoDetalles {
            id
            precio
            cantidad
            materiaPrima {
              id
              codigo
              tipo
              nombre
              categoria
              precio
            }
          }
          recepcion {
            id
            user {
              username
              nombre
              apellido
            }
            observaciones
            movimientoDetalles {
              id
              materiaPrima {
                id
              }
              cantidad
            }
            createdAt
          }
          createdAt
        }
      }
    `,
    {
      onCompleted: (data) => {
        if (!data?.movimientos[0]) return;
        setData(data.movimientos[0]);
      },
    }
  );
  const [getPedido, { loading }] = useLazyQuery(
    gql`
      query getPedido($id: ID) {
        pedidosCompra(filter: { id: $id }) {
          id
          tipoCompra
          numeroExpediente
          fechaSolicitud
          licitacionInicio
          licitacionFin
          objetoCompra
          domicilioEntrega
          responsable {
            nombre
            apellido
          }
          secretaria {
            id
            nombre
            secretario
          }
          detalles {
            id
            numero
            materiaPrima {
              id
              nombre
            }
            cantidad
            cantidadVerificada
            observacion
            precioEstimado
            nombreServicio
          }
          proveedores {
            documento
            razonSocial
            nombre
            apellido
            habilitado
            user {
              email
            }
          }
        }
      }
    `,
    {
      onCompleted: (data) => {
        if (!data?.pedidosCompra[0]) return;
        setData(data.pedidosCompra[0]);
      },
    }
  );

  function formatFechaVillaMercedes(fechaISO) {
    if (!fechaISO) return "Villa Mercedes (San Luis), -- de ----.";
    const [year, month] = fechaISO.split("-"); // "2025-08-01" → ["2025", "08", "01"]
    const meses = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];
    const mesIndex = parseInt(month, 10) - 1; // "08" → 8 → 7
    const mes = meses[mesIndex];
    const año = year;
    return `Villa Mercedes (San Luis), ${mes} de ${año}.`;
  }

  useEffect(() => {
    if (id) {
      getPedido({ variables: { id } });
    }
  }, [id]);

  useEffect(() => {
    if (data) {
      const newTextArray = [...textArray];
      newTextArray[0] = data.id;
      newTextArray[1] = data.tipoCompra?.toUpperCase();
      newTextArray[2] = data.objetoCompra || ".................";
      newTextArray[6] = formatFechaVillaMercedes(data.fechaSolicitud);
      newTextArray[8] = formatDate(data.licitacionInicio, "dd/MM/yyyy") || "--/--/--";
      newTextArray[9] = formatDate(data.licitacionFin, "dd/MM/yyyy") || "--/--/--";
      newTextArray[10] = data.domicilioEntrega || "....";
      newTextArray[11] = data.responsable?.nombre + " " + data.responsable?.apellido || "....";
      newTextArray[14] = data.id || "----/--";
      const total =
        data.detalles.reduce(
          (acc, detalle) => acc + detalle.cantidadVerificada * detalle.precioEstimado,
          0
        ) || 0;

      const formattedTotal = formatMoneyPuntoDecimal(total.toFixed(2));
      newTextArray[17] = "$ " + formattedTotal;
      newTextArray[18] = "$";
      newTextArray[19] = "000";
      newTextArray[20] = formatDate(data.fechaSolicitud, "dd/MM/yyyy") || "--/--/--";
      newTextArray[21] = data.secretaria?.secretario || "--";

      setTextArray(newTextArray);
    }
  }, [data]);
  const total =
    data?.detalles?.reduce(
      (acc, detalle) => acc + detalle.cantidadVerificada * detalle.precioEstimado,
      0
    ) || 0;

  const totalEnLetras = Money2Text(total).toUpperCase();

  // useEffect(() => {
  //   if (id) {
  //     getMovimiento({ variables: { id } });
  //   }
  // }, [id]);
  const removeHighlightBeforePrint = () => {
    const elements = document.querySelectorAll(".highlight");
    elements.forEach((el) => {
      el.classList.add("no-print-highlight");
    });
  };
  const handleGeneratePdf = async () => {
    setEditable(false);
    const document = documentsRef.current.childNodes[0];
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: "portrait",
      hotfixes: ["px_scaling"],
    });

    await doc.html(document, {
      margin: [50, 0, 50, 0],
      callback(doc) {
        doc.save(`exd-pedidoNro-${data.id}-Nota Secretario Académico.pdf`);
      },
    });
    setEditable(true);
  };

  const handleTextChange = (e, index) => {
    const newTextArray = [...textArray];
    newTextArray[index] = e.target.innerText;
    setTextArray(newTextArray);
  };

  return (
    <EmpleadoLayout>
      <SoftBox
        p={2}
        display="flex"
        alignItems="center"
        flexDirection="column"
        minHeight="100vh"
        height="100%"
      >
        <div ref={documentsRef}>
          <SoftBox
            sx={{
              position: "relative",
              overflow: "hidden",
              width: "794px",
              backgroundColor: "#ffffff",
              boxShadow: lg,
              px: 6,
            }}
            pb={5}
          >
            {/* ACA VA TODO EL CODIGO */}
            <PdfHeader />

            <SoftBox pb={5}>
              <SoftBox px={1}>
                <SoftTypography
                  variant="h6"
                  textAlign="end"
                  // sx={{
                  //   backgroundColor: editable ? "yellow" : "transparent",
                  // }}
                  //contentEditable
                >
                  {textArray[6]}
                </SoftTypography>
              </SoftBox>
              <SoftBox px={1}>
                <SoftTypography variant="h6" fontWeight="bold">
                  Rudy Roberto Camera
                </SoftTypography>
                <SoftTypography variant="h6" fontWeight="bold">
                  Universidad Provincial de Oficios
                </SoftTypography>
                <SoftTypography variant="h6" fontWeight="bold">
                  “EVA PERON”
                </SoftTypography>
                <SoftTypography variant="h6" fontWeight="bold">
                  Sr. Rector
                </SoftTypography>
                <SoftTypography variant="h6" fontWeight="bold">
                  S__________/__________D:
                </SoftTypography>
              </SoftBox>
            </SoftBox>
            <SoftTypography
              variant="body2"
              sx={{
                textIndent: "4em",
              }}
              textAlign="justify"
              pb={3}
            >
              En virtud de lo solicitado , se autoriza :{" "}
              <EditableText
                tooltip="Pedido realizado. Ej: (compra de motores para mezcladoras, destinada al
                reemplazo de los existentes en el Curso “Construye tu vivienda” correspondiente al
                1°cuatrimestre del ciclo lectivo 2024)"
                content={textArray[2]}
              />
              .
            </SoftTypography>
            <SoftTypography
              variant="body2"
              sx={{
                textIndent: "4em",
              }}
              textAlign="justify"
              pb={3}
            >
              Tengo el agrado de informar que apruebo se proceda con la adquisición sugerida, en las
              condiciones establecidas, según actuaciones labradas .
              {/* <EditableText
                tooltip="Actuaciones labradas. Ej: (NOTEDU N° 2198767/22 )"
                editable={editable}
                content={textArray[3]}
                color={"#9bf542"}
              />
              . */}
            </SoftTypography>
            <SoftTypography
              variant="body2"
              sx={{
                textIndent: "4em",
              }}
              textAlign="justify"
              pb={3}
            >
              El monto estimado de dicha adquisición asciende a la suma de{" "}
              <EditableText content={totalEnLetras} handleOnBlur={(e) => handleTextChange(e)} /> (
              <EditableText
                tooltip="Monto de la adquisición. Ej: ((PESOS CUARENTA Y DOS MIL CUATROCIENTOS SESENTA Y NUEVE
                con 20/100) $42.469,20)"
                content={textArray[17]}
              />
              ).
            </SoftTypography>
            <SoftTypography variant="body2" fontWeight="bold" textAlign="end" pb={1}>
              Sin otro motivo, saludo a usted atentamente.
            </SoftTypography>
            <SoftTypography variant="body2" fontWeight="bold" textAlign="end" pb={1}>
              <EditableText
                tooltip="Ej.: (Ing / CPN / Sr)"
                editable={editable}
                content={textArray[4]}
              />{" "}
              <EditableText
                tooltip="Nombre del Emisor. Ej: (Ing. Lautaro Sosa)"
                content={textArray[21]}
              />
            </SoftTypography>
            <SoftTypography variant="body2" fontWeight="bold" textAlign="end">
              Universidad Provincial de Oficios “Eva Perón”
            </SoftTypography>
          </SoftBox>
        </div>
        <SoftBox
          variant="contained"
          bgColor="white"
          p={2}
          style={{
            position: "fixed",
            bottom: "1.5rem",
            right: "1.5rem",
            zIndex: 1000,
            boxShadow:
              "inset 0rem 0rem 0.0625rem 0.0625rem rgb(255 255 255 / 90%), 0rem 1.25rem 1.6875rem 0rem rgb(0 0 0 / 5%)",
            borderRadius: "16px",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: `saturate(200%) blur(${pxToRem(30)})`,
          }}
        >
          <Grid container spacing={2} justifyContent="flex-end" id="button">
            <Grid item>
              <SoftButton variant="gradient" color="error" onClick={handleGeneratePdf}>
                <Icon fontWeight="bold">picture_as_pdf</Icon>
                &nbsp;&nbsp;Descargar PDF
              </SoftButton>
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
    </EmpleadoLayout>
  );
};

export default NotaSecretario;
